import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import User from '../../interfaces/user';

interface UserState {
    users: User[],
    clientManagerDescendants: string[]
}

const initialState: UserState = {
    users: [],
    clientManagerDescendants: []
}

export const UserSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        loadUsers: (state, action: PayloadAction<User[]>) => {
            state.users = action.payload
        },
        loadClientManagerDescendants: (state, action: PayloadAction<string[]>) => {
            state.clientManagerDescendants = action.payload
        },
    }
});

export const {loadUsers, loadClientManagerDescendants} = UserSlice.actions;

export default UserSlice.reducer;